<section #kendoScheduler>
  <kendo-scheduler
    class="scheduler"
    [kendoSchedulerBinding]="events"
    [selectedDate]="selectedDate"
    [resources]="resources"
    [loading]="loading"
    (eventClick)="clickDate($event)"
    (dateChange)="dateDisplay($event)"
    timezone="Europe/Paris"
    scrollTime="08:00"
    style="height: 720px; width: 100%;"
  >
    <kendo-scheduler-month-view> </kendo-scheduler-month-view>
    <kendo-scheduler-week-view> </kendo-scheduler-week-view>
    <kendo-scheduler-day-view> </kendo-scheduler-day-view>

    <kendo-scheduler-messages
      allDay=""
      showFullDay="journée complète"
      showWorkDay="horaires du bureau"
      dayViewTitle="jour"
      today="aujourd'hui"
      weekViewTitle="semaine"
      monthViewTitle="Mois"
    >
    </kendo-scheduler-messages>
  </kendo-scheduler>
</section>
